import * as Rox from "rox-browser";

export const dashboard = {
    pending_orders: new Rox.Flag(),
    credit_limit: new Rox.Flag(),
    credit_limit__graph: new Rox.Flag(),
    payments: new Rox.Flag(),
    payments__reconcile: new Rox.Flag(),
    payments__reference: new Rox.Flag(),
    payments__reference_reconcile: new Rox.Flag(),
    general_status: new Rox.Flag(),
    balance: new Rox.Flag(),
    carvajal: new Rox.Flag(),
    regex_test_APC: new Rox.Flag(),
    canAccessCXGO: new Rox.Flag(),
    enabledPagoEnLinea: new Rox.Flag()
};
